import http from '../../services/http';
import { ORDER_TYPE, pricesToShowByFormGroup } from '../utils';

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('getPricesByCityAndType', (formGroup) => ({
        formGroup,
        inputs: {
          entity_type:
            formGroup === 'search_by_state_c_corp_form' ? 'CCorporation' : '',
          entity_state: '',
        },
        errors: {},
        cityResult: {},
        async getStateTypePrice() {
          if (!this.inputs.entity_type || !this.inputs.entity_state) {
            return;
          }

          const apiUrl =
            import.meta.env.VITE_GET_PRICE_BY_STATE_URL ||
            'https://api.incfile.com/api/v1/get-price-by-state/';
          const response = await http.get(
            `${apiUrl}?state=${this.inputs.entity_state}&orderType=${ORDER_TYPE.REGISTERED_AGENT_CHANGE}`,
            { headers: null },
          );
          if (response.status !== 200) {
            return;
          }

          const { data } = response;

          this.cityResult.price =
            data?.[pricesToShowByFormGroup[formGroup].priceName] || 0;
          this.cityResult.stateFee =
            data?.[
              pricesToShowByFormGroup[formGroup].feeNames[
                this.inputs.entity_type
              ]
            ] || 0;
        },
        validateField(fieldName) {
          delete this.errors[fieldName];
          if (!this.inputs[fieldName]?.trim() && fieldName) {
            this.errors[fieldName] = 'Please complete this required field.';
          }
          this.getStateTypePrice();
        },
        validateAll() {
          this.validateField('entity_type');
          this.validateField('entity_state');
        },
        submit(baseURL) {
          this.validateAll();
          if (this.errors.entity_type || this.errors.entity_state) {
            return;
          }
          const url = `${baseURL}?entity_type=${this.inputs.entity_type}&entity_state=${this.inputs.entity_state}`;
          window.location.href = url;
          // Limpiar selects, errores y precio después del submit
          this.inputs.entity_type = '';
          this.inputs.entity_state = '';
          this.errors = {};
          this.cityResult = {};
        },
      }));
    });
  },
};
